import { useMutation } from '@tanstack/react-query';

import { useNotification } from '../../../../../hooks';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import * as service from '../services';

export const useDeleteOmnichannelSavedFilter = () => {
  const setOmnichannelClearSavedFilters = useOmnichannelStore(state => state.setOmnichannelClearSavedFilters);
  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);
  const { handleNotification } = useNotification();

  const successAction = () => {
    handleNotification('success', 'Filtro excluído com sucesso!');
    setOmnichannelClearSavedFilters();
    setOmnichannelState('showModalOmnichannelDeleteFilters', false);
  };

  const errorAction = () => {
    handleNotification('error', 'Erro ao excluir filtro');
    setOmnichannelState('showModalOmnichannelDeleteFilters', false);
  };

  const mutate = useMutation({
    mutationFn: (id: number) => service.deleteOmnichannelSavedFilters(id),
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    deleteOmnichannelSavedFilter: mutate.mutate,
    isDeleting: mutate.isPending,
  };
};
